export class VideoLibraryHelper {
  static copyLinkToClipboard(data: string): Promise<string> {
    /* Create the text field */
    const textInput = document.createElement('input');
    textInput.id = 'clipboard-dealroom-area';
    textInput.value = data;
    document.body.appendChild(textInput);

    /* Select the text field */
    const copyArea = document.getElementById('clipboard-dealroom-area') as HTMLInputElement;
    copyArea.select();
    copyArea.setSelectionRange(0, 99999); /*For mobile devices*/

    /* Copy the text inside the text field */
    const copyLinkPromise: Promise<string> = new Promise((res, rej) => {
      try {
        document.execCommand('copy', false, data);
        res(data);
      } catch (err) {
        rej(err);
      }
    });
    document.body.removeChild(copyArea);
    return copyLinkPromise;
  }
}
